const ENDPOINTS_PATHS = {
    "/CareForms": "/v1/CareForms",
    "/CareFormDetails(:appointment_id)": "/v1/CareFormDetails(:appointment_id)",
    "/Clickstream": "/v1/Clickstream",
};
export default ENDPOINTS_PATHS;